import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import {
  useCreateCourseFromStations,
  useModalConfirm,
  useSelectedIds,
  useStationsBulkActions,
} from "@ryde/redux";
import {
  ActionsEnum,
  ConfirmResult,
  RydeUiUnit,
  useIsMobile,
} from "@ryde/shared";

import { AccessControl } from "../../../access-control";
import { FloatingMenuButton } from "../../floating-menu.styled";
import { FloatingMenuTooltipWrapper } from "../../floating-menu.tooltip";

const entity: RydeUiUnit = "station";
const courseEntity: RydeUiUnit = "course";

export const StationExpand: FC = () => {
  const { selectedRowsIds } = useSelectedIds();
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const { bulkFindArea } = useStationsBulkActions();
  const { createCourseFromStations } = useCreateCourseFromStations();

  const handleFindAreaClick = useEvent(async () => {
    if (!selectedRowsIds.length) {
      return;
    }

    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message: t("station.FIND_AREA_CONFIRM"),
    });

    if (confirmationResult === ConfirmResult.OK) {
      await bulkFindArea(selectedRowsIds);
    }
  });

  const handleCreateCourseClick = useEvent(async () => {
    if (!selectedRowsIds.length) {
      return;
    }

    await createCourseFromStations(selectedRowsIds);
  });

  return (
    <>
      <AccessControl entity={entity} action={ActionsEnum.Update}>
        <FloatingMenuButton onClick={handleFindAreaClick}>
          {!isMobile && (
            <SVG_MUI.MenuMapSVG className="pointer" aria-hidden="true" />
          )}
          <span>{t("station.FIND_AREA")}</span>
        </FloatingMenuButton>
      </AccessControl>

      <AccessControl entity={courseEntity} action={ActionsEnum.Create}>
        <FloatingMenuTooltipWrapper
          tooltip={t("station.CREATE_COURSE_TOOLTIP")}
        >
          <FloatingMenuButton onClick={handleCreateCourseClick}>
            {!isMobile && (
              <SVG_MUI.Course4SVG
                className="pointer greyButton"
                aria-hidden="true"
              />
            )}
            <span>{t("station.CREATE_COURSE")}</span>
          </FloatingMenuButton>
        </FloatingMenuTooltipWrapper>
      </AccessControl>
    </>
  );
};
